export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7084.39fb0e24.jpg";